// ═══════════════════════════════════════════════════════════════════════════════
// Subscription / Stripe billing (§22.9)
// ═══════════════════════════════════════════════════════════════════════════════
export const SUBSCRIPTION_BILLING_MODE = {
    PREPAY_THEN_ANCHOR: 'prepay_then_anchor',
};
export const SUBSCRIPTION_STATUS = {
    ACTIVE: 'active',
    PAST_DUE: 'past_due',
    CANCELED: 'canceled',
    INCOMPLETE: 'incomplete',
};
//# sourceMappingURL=subscription.js.map